import 'jquery';
import Vue from 'vue';
import VueTippy from 'vue-tippy';
import ApartmentList from './vue/ApartmentList/ApartmentList.vue';
import Location from './vue/Location/Location.vue';

import header from './components/header';
import sellingPoints from './components/selling-points';
import video from './components/video';
import slider from './components/slider';
import accordion from './components/accordion';

Vue.use(VueTippy);
Vue.component('apartment-list', ApartmentList);
Vue.component('location', Location);

new Vue({
  el: '#app',
});

$(() => {
  header();
  sellingPoints();
  video();
  slider();
  accordion();
});
